import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeTeacherResourceActivitySkeleton } from './TypeTeacherResourceActivity'
import type { TypeTeacherResourceFilesSkeleton } from './TypeTeacherResourceFiles'

export interface TypeTeacherResourceCategoryFields {
  name: EntryFieldTypes.Symbol
  image?: EntryFieldTypes.AssetLink
  categories?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeTeacherResourceCategorySkeleton>>
  resources?: EntryFieldTypes.Array<
    EntryFieldTypes.EntryLink<TypeTeacherResourceActivitySkeleton | TypeTeacherResourceFilesSkeleton>
  >
  slug?: EntryFieldTypes.Symbol
  path?: EntryFieldTypes.Symbol
}

export type TypeTeacherResourceCategorySkeleton = EntrySkeletonType<
  TypeTeacherResourceCategoryFields,
  'teacherResourceCategory'
>
export type TypeTeacherResourceCategory<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeTeacherResourceCategorySkeleton, Modifiers, Locales>

export function isTypeTeacherResourceCategory<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeTeacherResourceCategory<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'teacherResourceCategory'
}

export type TypeTeacherResourceCategoryWithoutLinkResolutionResponse =
  TypeTeacherResourceCategory<'WITHOUT_LINK_RESOLUTION'>
export type TypeTeacherResourceCategoryWithoutUnresolvableLinksResponse =
  TypeTeacherResourceCategory<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeTeacherResourceCategoryWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> =
  TypeTeacherResourceCategory<'WITH_ALL_LOCALES', Locales>
export type TypeTeacherResourceCategoryWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeTeacherResourceCategory<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeTeacherResourceCategoryWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeTeacherResourceCategory<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
